import { RAG_META } from "@/lib/rag";

export default function ScoreGauge({ score = 0, rag = "green", questionsAnswered = 0, totalQuestions = 7 }) {
  const meta = RAG_META[rag] || RAG_META.green;
  const pct = totalQuestions > 0 ? Math.min(100, Math.round((questionsAnswered / totalQuestions) * 100)) : 0;
  return (
    <div className={`p-5 rounded-lg border border-slate-800 bg-slate-900/60 ${meta.ring} ring-1`} data-testid="score-gauge">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-num">Live Risk Score</div>
          <div className="text-4xl font-mono-num mt-1" data-testid="score-total">{Number(score).toFixed(1)}</div>
        </div>
        <div className={`px-3 py-1.5 rounded-md text-xs font-semibold uppercase tracking-widest ${meta.cls}`} data-testid="score-rag-badge">
          <span className={`inline-block h-2 w-2 rounded-full mr-2 align-middle ${meta.dot}`} />
          {meta.label}
        </div>
      </div>
      <div className="h-2 w-full rounded bg-slate-800 overflow-hidden">
        <div className={`h-full transition-all duration-300 ${meta.dot}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1.5 flex items-center justify-between text-xs text-slate-500 font-mono-num">
        <span>{questionsAnswered}/{totalQuestions} questions</span>
        <span>{pct}%</span>
      </div>
    </div>
  );
}
